import type * as React from 'react';
import { post } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import passwordResetRequested, {
	type PasswordResetRequestedAction,
} from '@Application/Users/Users/Actions/passwordResetRequested';
import passwordResetRequestFailed, {
	type PasswordResetRequestFailedAction,
} from '@Application/Users/Users/Actions/passwordResetRequestFailed';
import type RequestPasswordReset from '@Application/Users/Users/Commands/RequestPasswordReset';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = PasswordResetRequestedAction | PasswordResetRequestFailedAction;

export default (command: RequestPasswordReset) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// The administration route answers 200 with the user, unlike the public route (204).
			const payload = await post<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}/password-resets`,
				{},
			);

			const action = passwordResetRequested(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = passwordResetRequestFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
